import { createAsyncThunk } from '@reduxjs/toolkit';
import { EApiStatuses } from '../../../constants';
import {IError, IPagePayload} from '../../../models/inner-models';
import {IDeleteChatgptPayload, IDeletePayload, ISetterUserWithProjects} from '../../../models/models';
import { EPlatform, EPlatformNames } from '../../constants';
import { addPlatformIdentifier } from '../../functions';
import instance from '../../middlewares/api';

const fetchChatgptUsers = createAsyncThunk(
  addPlatformIdentifier(EPlatform.fetchPlatformUsers, EPlatformNames.chatgpt),
  async (_, thunkAPI) => {
    try {
      const resp = await instance.get('chatgpt/profiles');
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        undefined : resp.data.result;
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const addChatgptUser = createAsyncThunk(
  addPlatformIdentifier(EPlatform.addPlatformUser, EPlatformNames.chatgpt),
  async (_, thunkAPI) => {
    try {
      const resp = await instance.get('gitlab/add-gitlab-user');
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: resp.data.message }) :
        resp?.data?.result;
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const getAvailableItemsForChatgptUser = createAsyncThunk(
  addPlatformIdentifier(EPlatform.getAvailableItems, EPlatformNames.chatgpt),
  async (payload: IPagePayload, thunkAPI) => {
    try {
      const resp = await instance.get(`gitlab/get-available-projects-for-gitlab-user?page=${payload.page}&perPage=${payload.perPage}${payload.name? `&name=${payload.name}`:''}`, { signal:payload.signal });
      return resp?.data?.result?.not_added_projects || [];
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const editChatgptUser = createAsyncThunk(
  addPlatformIdentifier(EPlatform.editPlatformUser, EPlatformNames.chatgpt),
  async (_, thunkAPI) => {
    try {
      const resp = await instance.get('gitlab/change-gitlab-user');
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: resp.data.message }) :
        resp?.data?.result;
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const fetchItemsForChatgptUser = createAsyncThunk(
  addPlatformIdentifier(EPlatform.fetchUserItems, EPlatformNames.chatgpt),
  async (payload: IPagePayload, thunkAPI) => {
    try {
      const resp = await instance.get(`chatgpt/conversations?page=${payload.page}&perPage=${payload.perPage}${payload.name? `&name=${payload.name}`:''}${payload.filter ? `&${payload.filter}`:''}`);
      return resp?.data?.result || [];
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const addChatgptItems = createAsyncThunk(
  addPlatformIdentifier(EPlatform.addItem, EPlatformNames.chatgpt),
  async (projectsWithUser: ISetterUserWithProjects, thunkAPI) => {
    try {
      const resp = await instance.post('gitlab/add-gitlab-projects', projectsWithUser);
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ status: resp.data.status, error: resp.data.message }) :
        resp.data.result.projects_list;
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const deleteChatgptItem = createAsyncThunk(
  addPlatformIdentifier(EPlatform.deleteItem, EPlatformNames.chatgpt),
  async (payload: IDeleteChatgptPayload, thunkAPI) => {
    try {
      const resp = await instance.post('chatgpt/delete-backup', payload);
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: resp.data.message }) : resp.data;
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

const backupChatgptItem = createAsyncThunk(
  addPlatformIdentifier(EPlatform.backupItem, EPlatformNames.chatgpt),
  async (idRepo: string, thunkAPI) => {
    try {
      const resp = await instance.post('gitlab/backup-now', {
        projectId: idRepo,
      });
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: resp.data.message }) : resp.data;
    } catch (err) {
      const error = err as IError;
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

export {
  fetchItemsForChatgptUser,
  getAvailableItemsForChatgptUser,

  addChatgptItems,
  deleteChatgptItem,
  backupChatgptItem,

  fetchChatgptUsers,
  addChatgptUser,
  editChatgptUser,
};
